import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { ExceptionCalendarEvent } from '../../../types';
import { EventCardWrapper } from '../../column-events/event-card-wrapper';
import { stripeBackgroundStyle } from '../../styles';

interface Props {
  event: ExceptionCalendarEvent;
}
export const ExceptionEvent = ({ event }: Props) => {
  return (
    <EventCardWrapper eventType={'exception'} containerStyle={[stripeBackgroundStyle, containerStyle]}>
      {event.eventType}
    </EventCardWrapper>
  );
};

const containerStyle = css({
  padding: theme.spacing(0.5),
});
